<template>
    <div>
        <div class="resourceRecycle-title">
            <div>{{$t('resourceLifecycle.resourceRecycle')}}</div>
        </div>
        <div class="resourceRecycle-top">
            <resource-basic-information-search></resource-basic-information-search>
        </div>
    </div>
</template>

<script>
  import ResourceBasicInformationSearch from '../resource_recycle/ResourceBasicInformationSearch'
    export default {
        name: 'ResourceRecycle',
        components: {
            ResourceBasicInformationSearch
        },
        data () {
            return {
            }
        },
        methods: {
        }
    }
</script>

<style scoped>
    .resourceRecycle-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 15px 4px;
        font-weight: 600;
        overflow: hidden;
    }
    .resourceRecycle-title>div:nth-child(1)
    {
        float:left;
    }
    .resourceRecycle-top
    {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_recycle/ResourceRecycle.vue